import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ImageService } from '../../../../../services/image/image.service';
import { FormatService } from '../../../../../common/format/format.service';
import { TooltipDirective } from '../../../../../common/directives/tooltip/tooltip.directive';
import { DecimalPipe } from '@angular/common';
import { MagicSearchService } from '../../../../../pages/creators/service/magic-search/magic-search.service';
import { LiteRowActionsComponent } from '../../../../../pages/manage-brief/molecules/lite-row-actions/lite-row-actions.component';
import { ManageBriefTabsService } from '../../../service/manage-brief-tabs/manage-brief-tabs.service';
import { BriefService } from '../../../../../services/brief/brief.service';
import { SocialScreeningService } from '../../../../../services/social-screening/social-screening.service';
import { Router } from '@angular/router';

@Component({
  selector: 'brief-feed-applied',
  standalone: true,
  imports: [],
  templateUrl: './feed-applied.component.html',
  styleUrl: './feed-applied.component.css'
})
export class FeedAppliedComponent {

  @Input('activity') activity: any;

  @Output() viewApplicantsOut = new EventEmitter<void>();

  /** Services */
  private router = inject(Router);
  public formatService = inject(FormatService);
  public imageService = inject(ImageService);
  public magicSearchService = inject(MagicSearchService);
  public manageBriefTabsService = inject(ManageBriefTabsService);
  public briefService = inject(BriefService);
  private socialScreeningService = inject(SocialScreeningService);
  /** Services END */


  promoteCreator(applicant: any) {
    console.log('promoteCreator', applicant);
    if (this.briefService.creatorsToPromote().indexOf(applicant) == -1) {
      this.briefService.creatorsToPromote.set([...this.briefService.creatorsToPromote(), applicant]);
    } else {
      this.briefService.creatorsToPromote.set(this.briefService.creatorsToPromote().filter(creator => creator.id !== applicant.id));
    }
    console.log('creatorsToPromote', this.briefService.creatorsToPromote);
  }

  screenCreator(applicant: any) {
    const alreadySelected = this.briefService.creatorsToScreen().indexOf(applicant) !== -1;
    if (alreadySelected) {
      this.briefService.creatorsToScreen.set(this.briefService.creatorsToScreen().filter(creator => creator.id !== applicant.id));
      return;
    }
    if (!this.socialScreeningService.canScreenCreator(applicant.creator)) {
      this.socialScreeningService.notifyCannotScreen(applicant.creator);
      return;
    }
    this.briefService.creatorsToScreen.set([...this.briefService.creatorsToScreen(), applicant]);
  }

  viewApplicants() {
    console.log('viewApplicants()');
    if (this.activity.briefApplications.length > 0) {
      this.viewApplicantsOut.emit();
    }
  }

  onCardKeydown(event: Event): void {
    const keyEvent = event as KeyboardEvent;
    if (keyEvent.key !== 'Enter' && keyEvent.key !== ' ') {
      return;
    }
    if (keyEvent.key === ' ') {
      keyEvent.preventDefault();
    }
    this.viewApplicants();
  }
  
  toggleCreatorPortfolio(applicant: any, type: 'profile' | 'portfolio' | 'tiktok' | 'instagram' | 'snapchat' | 'youtube') {
    console.log('toggleCreatorPortfolio(): ', applicant, type);
    this.magicSearchService.portfolioCreatorId.set(applicant.creator?.blazeFirebaseUid);
    this.magicSearchService.portfolioCreator.set(applicant.creator);
    this.magicSearchService.portfolioBriefApplication.set(applicant);
  }


  recommendColour(wouldRecommendPercentage: number): string {
    if (wouldRecommendPercentage < 26) {
      return 'text-red-500'
    } else if (wouldRecommendPercentage < 51) {
      return 'text-orange-500'
    } else if (wouldRecommendPercentage < 76) {
      return 'text-accent'
    } else {
      return 'text-green-500'
    }
  }

  getRatingColour(averageRating: number): string {
    if (averageRating <= 2) {
      return 'bg-red-50 dark:bg-red-900/30 text-red-700 ring-red-600'
    } else if (averageRating > 2 && averageRating <= 3) {
      return 'bg-amber-50 dark:bg-amber-900/30 text-amber-700 ring-amber-600'
    } else if (averageRating > 3 && averageRating <= 4) {
      return 'bg-primary/10 dark:bg-primary/25 text-accent ring-primary/25'
    } else {
      return 'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 ring-emerald-600'
    }
  }
}
